export const END_USER_REGEX = /^@(?<uuid>[0-9a-zA-Z-_]+)_(?<account_id>\d{1,12})_e:.*$/
export const AGENT_USER_REGEX = /^@(?<agent_id>\d{1,12})_(?<account_id>\d{1,12})_a:.*$/
export const SUPER_USER_REGEX = /^@(?<agent_id>\d{1,12})_s:.*$/
export const BOT_USER_REGEX = /^@chat-admin:.*$/
export const CHAT_ADMIN_NAME = 'Bot'
